import { PropTypes } from "prop-types"
import { useContext } from "react"
import AppContext from "~/contexts/App"
import { permissionAllowed } from "~/utils/permissionAllowed"

//component to wrap around components that need to be hidden from certain permission groups (super, admin, read-only)
// or permissions (discounts, analytics, labs, clients, categories)
const PermissionsWrapper = ({ permissionGroup, permissionType, children }) => {
  const { authUser } = useContext(AppContext)
  if (!authUser) {
    return null
  }

  const {
    permissions: userPermissions,
    permission_group: userPermissionGroup,
  } = authUser

  if (userPermissionGroup === "super") {
    return children
  }

  let allowed = false

  allowed = permissionAllowed(
    permissionGroup,
    userPermissionGroup,
    permissionType,
    userPermissions,
  )

  return allowed ? children : null
}

PermissionsWrapper.propTypes = {
  children: PropTypes.node,
  permissionType: PropTypes.string,
  permissionGroup: PropTypes.oneOf(["read-only", "super", "admin"]),
}
export default PermissionsWrapper
